import { useTranslation } from 'react-i18next';
import { Icon, type IconName } from '@hp/ui';
import type { PipelineState } from './queries';
import { fmtInt } from '../../lib/format';

// --- d) Totals strip ---

export function TotalsStrip({ totals }: { totals: PipelineState['totals'] }) {
  const { t } = useTranslation(['pipeline', 'common']);
  const items: Array<[string, IconName, number]> = [
    [t('totals.persons'), 'users', totals.persons],
    [t('totals.organizations'), 'building', totals.organizations],
    [t('totals.subjects'), 'database', totals.subjects],
  ];
  return (
    <div className="bo-metrics" aria-label={t('totals.aria')}>
      {items.map(([label, icon, value]) => (
        <div key={label} className="bo-metric">
          <span className="bo-metric__icon">
            <Icon name={icon} />
          </span>
          <span>
            <strong>{fmtInt(value)}</strong>
            <small>{label}</small>
          </span>
        </div>
      ))}
    </div>
  );
}
